import { render, staticRenderFns } from "./showcaseSkipIpCell.vue?vue&type=template&id=024ef190&scoped=true"
import script from "./showcaseSkipIpCell.vue?vue&type=script&lang=js"
export * from "./showcaseSkipIpCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ef190",
  null
  
)

export default component.exports